import { FC } from 'react';
import { TbKeyframe } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import { CALENDAR_EVENT_SOURCES, type CalendarEventSourceId, type CalendarEventTone } from './calendarEvents';

interface CalendarEventKeyframeProps {
    size?: string;
    source: CalendarEventSourceId;
}

const CalendarEventKeyframe: FC<CalendarEventKeyframeProps> = ({ size = '1rem', source }) => {
    const { token } = useAntDesignTheme();
    const sourceDefinition = CALENDAR_EVENT_SOURCES.find((definition) => definition.id === source);
    const tone: CalendarEventTone = sourceDefinition?.tone ?? 'blue';
    const fill = tone === 'gold' ? token.gold2 : token.blue2;
    const stroke = tone === 'gold' ? token.gold6 : token.blue6;

    return (
        <TbKeyframe
            aria-hidden
            fill={fill}
            size={size}
            stroke={stroke}
            style={{ flex: '0 0 auto', verticalAlign: '-0.175rem' }}
        />
    );
};

export default CalendarEventKeyframe;
